export default __webpack_public_path__ + "static/media/paytm.d2e8328a.png";